<template>
  <Container>
    <template #header>
      <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
    </template>
    <template #default>
      <div class="container px-4 mx-auto max-w-none">
        <Breadcrumbs
          :breadcrumbs="[
            { name: 'Dashboard', href: route('dashboard') },
            { name: `Berita`, href: route('berita.index') },
            {
              name: `${berita.data[0].title}`,
              href: route('berita.show', berita.data[0].idnews),
            },
          ]"
        />
        <div class="w-full">
          <div class="w-full rounded-lg">
            <div class="py-6 bg-white border rounded-lg shadow-sm">
              <dl class="divide-y divide-gray-200">
                <div class="grid grid-cols-1 gap-4 px-6 py-4 sm:grid-cols-4">
                  <dt class="font-semibold text-gray-800">Judul</dt>
                  <dd class="text-gray-700 sm:col-span-3">
                    {{ berita.data[0].title }}
                  </dd>
                </div>
                <div class="grid grid-cols-1 gap-4 px-6 py-4 sm:grid-cols-4">
                  <dt class="font-semibold text-gray-800">Berita</dt>
                  <dd
                    class="prose prose-lg text-gray-700 sm:col-span-3 max-w-none"
                    v-html="berita.data[0].content"
                  ></dd>
                </div>
                <div class="grid grid-cols-1 gap-4 px-6 py-4 sm:grid-cols-4">
                  <dt class="font-semibold text-gray-800">Jenis</dt>
                  <dd class="text-gray-700 sm:col-span-3">
                    {{ berita.data[0].slug }}
                  </dd>
                </div>
                <div class="grid grid-cols-1 gap-4 px-6 py-4 sm:grid-cols-4">
                  <dt class="font-semibold text-gray-800">Kategori</dt>
                  <dd class="text-gray-700 sm:col-span-3">
                    {{
                      berita.data[0].tags ? berita.data[0].tags.join(", ") : ""
                    }}
                  </dd>
                </div>
                <div class="grid grid-cols-1 gap-4 px-6 py-4 sm:grid-cols-4">
                  <dt class="font-semibold text-gray-800">Publikasi</dt>
                  <dd class="text-gray-700 sm:col-span-3">
                    {{ berita.data[0].publish_date }}
                  </dd>
                </div>
                <div class="grid grid-cols-1 gap-4 px-6 py-4 sm:grid-cols-4">
                  <dd class="sm:col-span-4">
                    <div class="flex justify-center">
                      <button
                        @click="editNews(berita.data[0].idnews)"
                        class="inline-flex items-center px-6 py-3 text-sm font-medium text-white transition-colors duration-200 bg-blue-600 border border-transparent rounded-lg shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          class="w-4 h-4 mr-1"
                        >
                          <path
                            d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z"
                          />
                          <path
                            d="M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z"
                          />
                        </svg>
                        Edit Content
                      </button>
                    </div>
                  </dd>
                </div>
              </dl>
            </div>
            <ModalEditNews
              v-model:isOpen="isModalOpen"
              :title="'Edit Berita'"
              :berita="viewNews"
              :allTags="tagsList"
              @close="isModalOpen = false"
            />
            <ModalFile
              v-model:isOpen="isModalFile"
              :title="'Edit File'"
              :gambarberita="viewNews"
            />
          </div>
        </div>
      </div>
    </template>
  </Container>
</template>

<script setup>
import { defineProps, watch, ref } from "vue";
import ModalEditNews from "@/Components/News/ModalEditNews.vue";
import ModalFile from "@/Components/News/ModalFile.vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";
import Header from "@/Components/Header.vue";
import Container from "@/Layouts/Container.vue";
const props = defineProps({
  berita: {
    type: Array,
    required: true,
  },
  allTags: {
    type: Array,
    required: true,
  },
});
const isModalOpen = ref(false);
const isModalFile = ref(false);
const viewNews = ref(null);
const tagsList = ref(null);

const filePath = ref(props.berita.data[0].image);

watch(
  () => props.berita,
  (newBerita) => {
    filePath.value = newBerita.data[0].image;
  }
);

const editNews = async (idnews) => {
  try {
    const response = await fetch(`/viewberita/${idnews}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    viewNews.value = data.berita;
    tagsList.value = data.allTags.map((tag) => tag.name);
    isModalOpen.value = true;
  } catch (error) {
    console.error("Error fetching data:", error.message);
  }
};
const editFile = async (idnews) => {
  try {
    const response = await fetch(`/viewberita/${idnews}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    viewNews.value = data.berita;

    isModalFile.value = true;
  } catch (error) {
    console.error("Error fetching data:", error.message);
  }
};
// Check if file is an image
function isImage(filePath) {
  return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filePath);
}

// Check if file is a PDF
function isPdf(filePath) {
  return /\.pdf$/i.test(filePath);
}
</script>

<style scoped>
/* Full-page content styling */
.prose {
  max-width: none !important;
}

/* Enhanced content area styling */
.prose :deep(img) {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  margin: 1.5rem 0;
}

.prose :deep(p) {
  line-height: 1.8;
  margin-bottom: 1.25rem;
  text-align: justify;
}

.prose :deep(h1),
.prose :deep(h2),
.prose :deep(h3),
.prose :deep(h4),
.prose :deep(h5),
.prose :deep(h6) {
  color: #1f2937;
  font-weight: 600;
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.prose :deep(ul),
.prose :deep(ol) {
  margin: 1.25rem 0;
  padding-left: 1.75rem;
}

.prose :deep(li) {
  margin-bottom: 0.5rem;
  line-height: 1.7;
}

.prose :deep(blockquote) {
  border-left: 4px solid #e5e7eb;
  padding-left: 1rem;
  margin: 1.5rem 0;
  font-style: italic;
  color: #6b7280;
  background-color: #f9fafb;
  padding: 1rem;
  border-radius: 0.375rem;
}

/* Enhanced layout responsiveness */
@media (max-width: 640px) {
  .prose :deep(img) {
    margin: 1rem 0;
  }

  .prose :deep(p) {
    text-align: left;
  }
}
</style>
